'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _instagramStoryReport = require('../../../components/instagram-story-report');

var _instagramStoryReport2 = _interopRequireDefault(_instagramStoryReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storyImageStyle = {
  width: 60,
  height: 40,
  objectFit: 'cover',
  cursor: 'pointer'
};

var cursorPointer = {
  cursor: 'pointer',
  color: '#20c49e'
};

var smallFont = {
  fontSize: '60%',
  color: 'grey'
};

var StoryImageModalComponent = function StoryImageModalComponent(_ref) {
  var story = _ref.story;
  return _react2.default.createElement(
    _semanticUiReact.Modal,
    {
      trigger: _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        style: storyImageStyle,
        src: story.attributes.savedThumbnailUrl
      })
    },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      null,
      'Story Performance'
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(_instagramStoryReport2.default, { story: story })
    )
  );
};

var StoryIconModalComponent = function StoryIconModalComponent(_ref2) {
  var story = _ref2.story,
      _ref2$inManualStoryMo = _ref2.inManualStoryMode,
      inManualStoryMode = _ref2$inManualStoryMo === undefined ? false : _ref2$inManualStoryMo;
  return _react2.default.createElement(
    _semanticUiReact.Modal,
    {
      trigger: _react2.default.createElement(
        'div',
        { style: cursorPointer },
        _react2.default.createElement(_semanticUiReact.Icon, {
          title: 'view full story performance data (including media)',
          name: 'expand'
        }),
        _react2.default.createElement(
          'div',
          { style: smallFont },
          'view...'
        )
      )
    },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      null,
      'Story Performance'
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(_instagramStoryReport2.default, { story: story, inManualStoryMode: inManualStoryMode })
    )
  );
};

module.exports = {
  StoryIconModalComponent: StoryIconModalComponent,
  StoryImageModalComponent: StoryImageModalComponent
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/components/story-components.js
 ** module id = 2615
 ** module chunks = 0
 **/